import { useEffect, useState, useRef } from 'react';
import initEcho from '../echo';

export default function NotificationBell({ apiClient, apiPrefix = '/admin', tokenKey = 'admin_token', channelPrefix = 'admin' }) {
  const [notifiche, setNotifiche] = useState([]);
  const [nonLette, setNonLette] = useState(0);
  const [open, setOpen] = useState(false);
  const channelRef = useRef(null);

  const load = async () => {
    try {
      const res = await apiClient.get(`${apiPrefix}/notifiche`);
      setNotifiche(res.data.data || []);
      setNonLette(res.data.non_lette || 0);
    } catch {
      // silenzioso se non autenticato
    }
  };

  useEffect(() => {
    load();

    // Polling di fallback ogni 5 minuti
    const interval = setInterval(load, 300000);

    // WebSocket via Laravel Echo (Reverb/Pusher)
    let channel = null;
    try {
      channel = initEcho(tokenKey, channelPrefix);
      if (channel) {
        channel.listen('.notifica.inviata', (payload) => {
          setNotifiche((prev) => [payload, ...prev].slice(0, 50));
          setNonLette((n) => n + 1);
        });
        channelRef.current = channel;
      }
    } catch {
      // Echo non configurato: resta solo polling
    }

    return () => {
      clearInterval(interval);
      if (channelRef.current) {
        try {
          channelRef.current.stopListening('.notifica.inviata');
        } catch (_) {}
      }
    };
  }, [apiPrefix, tokenKey, channelPrefix]);

  const markRead = async (id) => {
    await apiClient.patch(`${apiPrefix}/notifiche/${id}/letta`);
    load();
  };

  const markAll = async () => {
    await apiClient.patch(`${apiPrefix}/notifiche/letta-tutte`);
    load();
  };

  return (
    <div className="position-relative me-3">
      <button
        type="button"
        className="btn btn-link position-relative p-0 text-dark"
        onClick={() => setOpen(!open)}
        aria-label="Notifiche"
      >
        <i className="bi bi-bell fs-5" />
        {nonLette > 0 && (
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {nonLette > 9 ? '9+' : nonLette}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: 1040 }} onClick={() => setOpen(false)} />
          <div
            className="position-absolute end-0 mt-2 bg-white rounded-3 shadow-lg border"
            style={{ width: 320, maxHeight: 400, overflowY: 'auto', zIndex: 1050 }}
          >
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
              <strong>Notifiche</strong>
              {nonLette > 0 && (
                <button type="button" className="btn btn-sm btn-link p-0" onClick={markAll}>
                  Segna tutte lette
                </button>
              )}
            </div>
            {notifiche.length === 0 ? (
              <p className="text-muted text-center p-4 mb-0">Nessuna notifica</p>
            ) : (
              notifiche.map((n) => (
                <div
                  key={n.id}
                  className={`p-3 border-bottom ${n.letta ? '' : 'bg-light'}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => { markRead(n.id); if (n.link) window.location.href = n.link; }}
                >
                  <div className="fw-semibold small">{n.titolo}</div>
                  <div className="text-muted small">{n.messaggio}</div>
                  <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                    {new Date(n.created_at).toLocaleString('it-IT')}
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}
